import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

// --- Talep sahibi ----------------------------------------------------------

// Ekran görüntülü destek talebi oluşturur (multipart/form-data).
// company_id / user_id backend'de token'dan alınır — gönderilmez.
export const useSupportRequestCreate = (onSuccess?: any, onError?: any) => {
  // Content-Type elle AYARLANMAZ: FormData verildiğinde tarayıcı doğru
  // multipart boundary'sini otomatik ekler; elle ayarlarsak boundary kaybolur.
  return useMutation(
    (formData: FormData) => axios.post(`${REACT_APP_API_URL}/support-requests/create`, formData),
    { onSuccess, onError },
  );
};

export const useMySupportRequests = (enabled = true, onError?: any) => {
  const fetchData = async () => {
    const res = await axios.get<any>(`${REACT_APP_API_URL}/support-requests/my`);
    return res?.data || {};
  };
  return useQuery(['support-requests-my'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    enabled,
    retry: false,
  });
};

// --- Ortak (talep sahibi veya admin) --------------------------------------

export const useSupportRequestDetail = (id?: number, onError?: any) => {
  const fetchData = async () => {
    const res = await axios.get<any>(`${REACT_APP_API_URL}/support-requests/detail`, { params: { id } });
    return res?.data || {};
  };
  return useQuery(['support-request-detail', id], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    enabled: !!id,
    retry: false,
  });
};

// --- Admin -----------------------------------------------------------------

export const useSupportRequestList = (params: any, onError?: any) => {
  const fetchData = async () => {
    const res = await axios.get<any>(`${REACT_APP_API_URL}/support-requests/list`, { params });
    return res?.data || {};
  };
  return useQuery(['support-requests-list', params], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    keepPreviousData: true,
    retry: false,
  });
};

export const useSupportRequestUpdate = (onSuccess?: any, onError?: any) => {
  const queryClient = useQueryClient();
  return useMutation((payload: any) => axios.patch(`${REACT_APP_API_URL}/support-requests/update`, payload), {
    onSuccess: (...args: any[]) => {
      queryClient.invalidateQueries(['support-requests-list']);
      queryClient.invalidateQueries(['support-requests-pending-count']);
      onSuccess && onSuccess(...args);
    },
    onError,
  });
};

// Bekleyen (yeni/açık) geri bildirim sayısı — badge için. Sadece geri bildirimi
// yöneten kullanıcıda çağrılır (enabled). status='open' olanların toplamını döndürür.
export const usePendingSupportRequestsCount = (enabled = true) => {
  const fetchData = async () => {
    const res = await axios.get<any>(`${REACT_APP_API_URL}/support-requests/list`, { params: { status: 'open', limit: 1 } });
    return res?.data?.totalResults || 0;
  };
  return useQuery(['support-requests-pending-count'], fetchData, {
    enabled,
    refetchOnWindowFocus: true,
    refetchInterval: 60000,
    retry: false,
  });
};
